import * as Animate from "react-reveal";
import { Link } from "react-router-dom";
import Avatar from "../../../assets/images/png/utiva.png";
import { getMarkerWord } from "../../../utils/storyMarker";

const highlightStyle = {
  background: "linear-gradient(transparent 74%, #fbaf1b 0)",
};

const StoriesHeader = ({ stories, handleShowForm }) => {
  const featured = stories?.[0];
  const featuredImage =
    featured?.imageUrl && !featured.imageUrl.includes("cloudinary")
      ? featured.imageUrl
      : Avatar;

  return (
    <section
      className="w-full relative overflow-hidden border-b border-[#dbe3f4]"
      style={{
        background:
          "linear-gradient(0deg, rgba(5,7,148,0.035) 1px, transparent 1px) 0 0/48px 48px, linear-gradient(90deg, rgba(5,7,148,0.035) 1px, transparent 1px) 0 0/48px 48px, linear-gradient(128deg,#f8faff 0%,#fff 54%,#fff8e8 100%)",
      }}
    >
      <div
        className="container mx-auto grid stories-grid-hero gap-9 lg:gap-[58px] items-center px-6 lg:px-8 py-10 lg:py-[52px]"
        style={{ minHeight: "450px" }}
      >
        <Animate.Fade bottom>
          <div>
            <p className="flex items-center gap-3 text-primary text-[15px] font-extrabold tracking-[0.1em] uppercase mb-[15px]">
              <span className="w-[35px] h-[3px] bg-secondary inline-block shrink-0"></span>
              Utiva Talent Stories
            </p>
            <h1
              className="text-primary tracking-[-0.058em] leading-[1.02] font-black max-w-[650px] mb-[18px]"
              style={{ fontSize: "clamp(47px, 5.3vw, 71px)" }}
            >
              Real people building{" "}
              <span className="relative inline" style={highlightStyle}>
                new possibilities.
              </span>
            </h1>
            <p className="text-[#5a6275] max-w-[650px] text-[17px] leading-[1.72] m-0">
              See what learners built, understood and became more confident
              doing—with the people behind the progress visible from the start.
            </p>

            <div className="flex flex-wrap gap-[10px] mt-[25px]">
              <button
                type="button"
                onClick={handleShowForm}
                className="bg-secondary border border-secondary text-primary rounded-[11px] inline-flex items-center justify-center gap-[10px] text-[16px] font-extrabold px-[17px] hover:-translate-y-0.5 transition-all"
                style={{
                  minHeight: "49px",
                  boxShadow: "0 12px 28px rgba(251,175,27,0.25)",
                }}
              >
                Write Your Story <span aria-hidden="true">→</span>
              </button>
              <a
                href="#story-library"
                className="bg-primary border border-primary text-white rounded-[11px] inline-flex items-center justify-center gap-[10px] text-[16px] font-extrabold px-[17px]"
                style={{ minHeight: "49px" }}
              >
                Explore the stories <span aria-hidden="true">↓</span>
              </a>
              <Link
                to="/start"
                className="border border-primary text-primary rounded-[11px] inline-flex items-center justify-center gap-[10px] text-[16px] font-extrabold px-[17px] hover:bg-primary hover:text-white transition-colors"
                style={{ minHeight: "49px" }}
              >
                Find your programme <span aria-hidden="true">↗</span>
              </Link>
            </div>
          </div>
        </Animate.Fade>

        {featured && (
          <Animate.Fade bottom>
            <article
              className="bg-white border border-[#cfd9ee] rounded-[24px] grid stories-grid-featured overflow-hidden"
              style={{
                minHeight: "330px",
                boxShadow: "0 26px 70px rgba(25,34,78,0.14)",
              }}
            >
              <div
                className="relative overflow-hidden"
                style={{ background: "#e8edfa", minHeight: "330px" }}
              >
                <img
                  src={featuredImage}
                  alt={featured?.name}
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div
                  className="absolute inset-x-0 bottom-0"
                  style={{
                    top: "50%",
                    background:
                      "linear-gradient(transparent, rgba(5,7,92,0.8))",
                  }}
                />
                <span
                  className="absolute bg-secondary text-primary rounded-full text-[15px] font-extrabold tracking-[0.06em]"
                  style={{
                    bottom: "15px",
                    left: "15px",
                    maxWidth: "calc(100% - 30px)",
                    padding: "7px 10px",
                  }}
                >
                  {getMarkerWord(featured?.companyRole)}
                </span>
              </div>
              <div className="flex flex-col justify-center p-6 lg:p-[30px]">
                <p className="text-[#8c5b00] tracking-[0.09em] text-[15px] font-extrabold mb-2">
                  Featured Talent
                </p>
                <h2 className="text-primary tracking-[-0.035em] text-[30px] leading-[1.2] m-0">
                  {featured?.name}
                </h2>
                <span className="text-[#5a6275] text-[15px] font-semibold mt-1">
                  {featured?.companyRole}
                </span>
                <blockquote className="text-[#202332] text-[17px] font-semibold leading-[1.68] mt-[22px] m-0">
                  {featured?.experience}
                </blockquote>
              </div>
            </article>
          </Animate.Fade>
        )}
      </div>
    </section>
  );
};

export default StoriesHeader;
